import React from 'react';
import Typography from '@mui/material/Typography';
import Tags from 'components/Tags';
import { styled } from '@mui/system';
import EyeIcon from 'assets/icons/eye.svg?react';

const Wrapper = styled('div')(({ theme }) => ({
  paddingTop: 40,
  [theme.breakpoints.down('sm')]: {
    paddingTop: 50
  }
}));

const Title = styled(Typography)(({ theme }) => ({
  textAlign: 'left',
  color: theme.palette.textPrimary.main,
  marginBottom: '10px',
  ...theme.textCut('3'),
  [theme.breakpoints.down('md')]: {
    fontSize: 24,
    lineHeight: '28px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 18,
    lineHeight: '18px'
  }
}));

const TemplateText = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  color: 'rgba(34, 34, 34, 0.6)',
  paddingBottom: 5,
  ...theme.textCut('4'),
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
    lineHeight: '20px'
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: 14,
    lineHeight: '14px'
  }
}));

const Viewers = styled('div')(() => ({
  position: 'absolute',
  bottom: 10,
  right: 15,
  display: 'flex',
  gap: 10,
  '& > p': {
    display: 'flex',
    alignItems: 'center',
    paddingBottom: 0,
    '& svg': {
      marginRight: 5
    }
  }
}));

const CardTemplate = ({ item }) => {
  const Body = React.useCallback(
    () => (
      <>
        <Title variant="h3">{item?.title}</Title>

        <Tags
          list={[
            {
              _id: item?.category?.name,
              name: item?.category?.nameUA || item?.category?.name
            }
          ]}
        />

        <TemplateText>{item?.meta?.excerpt}</TemplateText>

        {item?.viewsCount ? (
          <Viewers>
            <TemplateText>
              <EyeIcon />
              {item?.viewsCount}
            </TemplateText>
          </Viewers>
        ) : null}
      </>
    ),
    [item]
  );

  if (item?.postImage) {
    return (
      <>
        <Body />
      </>
    );
  }

  return (
    <Wrapper>
      <Body />
    </Wrapper>
  );
};

export default CardTemplate;
